interface SkipFeedIconProps {
  size?: number;
  className?: string;
}

/** A hump-shaped arrow (vertically stretched arc from -45° to 45°, arrowhead at the right end): "skip this feed". */
const SkipFeedIcon: React.FC<SkipFeedIconProps> = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    aria-hidden="true"
  >
    <path d="M2.34 12A8 22 0 0 1 13.66 12" />
    <path d="M14.75 8.99L13.66 12L10.89 10.4" />
  </svg>
);

export default SkipFeedIcon;
